import {useStores} from '@modules'
import * as css from './LibraryBoard.css'
import { React, observer, observable, useLocalStore } from '@api'
import {Library} from "./Library"
class MyStore {
  @observable foo = false
}

/**
 * dead code
 */
export const LibraryBoard = observer(() => {
  const store = useLocalStore(() => new MyStore()),
    { } = store
  const {
    workspaces: { workspaceConfig: { view }}
  } = useStores()

  if (view != 'library') {
    return <div>Error - this component is for rendering boards with view == 'library'</div>
  }
  return (
  <Library/>
  )
})


// WEBPACK FOOTER //
// ./src/modules/libraries/components/LibraryBoard.tsx